module.exports = __webpack_public_path__ + "static/media/enterArrow.7417aecd.svg";